import { render, staticRenderFns } from "./SurveyView.vue?vue&type=template&id=2d4a858e&scoped=true"
import script from "../js/Survey?vue&type=script&lang=js&external"
export * from "../js/Survey?vue&type=script&lang=js&external"
import style0 from "./SurveyView.vue?vue&type=style&index=0&id=2d4a858e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a858e",
  null
  
)

export default component.exports